var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":"Your response","disabled":_vm.disabledAnswers},on:{"input":function($event){_vm.updateAnswer($event)}},model:{value:(_vm.answer),callback:function ($$v) {_vm.answer=$$v},expression:"answer"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bf43048","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/single/TextAnswer.vue
// module id = 962
// module chunks = 1